import React, { useState } from "react";
import { InputGroup, FormControl, Button, Form } from "react-bootstrap";
import UseQueryMemberBy from "../../../hooks/UseQueryMemberById";

function SearchField() {
  const [searchTerm, setSearchTerm] = useState("");
  const { memberById } = UseQueryMemberBy();

  const handleFormSubmit = (e) => {
    e.preventDefault();
    memberById(searchTerm);
  };

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <Form onSubmit={handleFormSubmit} className="mb-4">
      <InputGroup>
        <FormControl
          placeholder="Search by student ID"
          aria-label="Search"
          onChange={handleInputChange}
          value={searchTerm}
        />
        <Button type="submit" variant="primary">
          Search
        </Button>
      </InputGroup>
    </Form>
  );
}

export default SearchField;
